import { useMemo, useState } from 'react';

export const useIndividualsFilters = (
    individuals,
    initialSelectedCompany = null,
    companyTypes = []
) => {
    const companyName =
        initialSelectedCompany?.properties?.name?.toLowerCase().trim() ??
        initialSelectedCompany?.name?.toLowerCase().trim();

    // const companyId =
    //     initialSelectedCompany?.properties?.uniqueId ??
    //     initialSelectedCompany?.uniqueId;

    const politicalTypes = useMemo(() => {
        const unique = [
            ...new Set(
                individuals.flatMap((i) => i.politicalAffiliation || [])
            ),
        ].filter(Boolean);
        return unique.map((value, id) => ({ id, value, label: value }));
    }, [individuals]);

    const sectorTypes = useMemo(() => {
        const unique = [
            ...new Set(individuals.flatMap((i) => i.sectors || [])),
        ].filter(Boolean);
        return unique.map((value, id) => ({ id, value, label: value }));
    }, [individuals]);

    // const companyTypes = useMemo(() => {
    //     const unique = [
    //         ...new Set(individuals.flatMap((i) => i.companyNames || [])),
    //     ];
    //     return unique.map((value, id) => ({ id, value, label: value }));
    // }, [individuals]);

    const initialSelectedCompanies = useMemo(() => {
        if (!companyName) return {};

        const matches = companyTypes.filter((c) =>
            c.value?.toLowerCase().includes(companyName)
        );

        return Object.fromEntries(matches.map((m) => [m.value, true]));
    }, [companyName, companyTypes]);

    // const initialSelectedCompanies = useMemo(() => {
    //     if (!companyId) return {};

    //     const matches = companyTypes.filter((c) => c.id === companyId);

    //     return Object.fromEntries(matches.map((m) => [m.value, true]));
    // }, [companyId, companyTypes]);

    const [selectedPolitics, setSelectedPolitics] = useState({});
    const [selectedSectors, setSelectedSectors] = useState({});
    const [selectedCompanies, setSelectedCompanies] = useState(
        initialSelectedCompanies
    );
    const [searchTerm, setSearchTerm] = useState('');

    const filteredIndividuals = useMemo(() => {
        return individuals.filter((i) => {
            const matchSearch = i.name
                .toLowerCase()
                .includes(searchTerm.toLowerCase());

            const matchPolitics =
                !Object.values(selectedPolitics).some(Boolean) ||
                (i.politicalAffiliation || []).some((p) => selectedPolitics[p]);

            const matchSector =
                !Object.values(selectedSectors).some(Boolean) ||
                (i.sectors || []).some((s) => selectedSectors[s]);

            const matchCompany =
                !Object.values(selectedCompanies).some(Boolean) ||
                (i.companyNames || []).some((c) => selectedCompanies[c]);

            return matchSearch && matchPolitics && matchSector && matchCompany;
        });
    }, [
        individuals,
        searchTerm,
        selectedPolitics,
        selectedSectors,
        selectedCompanies,
    ]);

    const activeFilters = useMemo(() => {
        let count = 0;

        if (searchTerm.length > 0) count++;
        count += Object.values(selectedPolitics).filter(Boolean).length;
        count += Object.values(selectedSectors).filter(Boolean).length;
        count += Object.values(selectedCompanies).filter(Boolean).length;

        return count;
    }, [searchTerm, selectedPolitics, selectedSectors, selectedCompanies]);

    return {
        politicalTypes,
        sectorTypes,
        companyTypes,
        selectedPolitics,
        setSelectedPolitics,
        selectedSectors,
        setSelectedSectors,
        selectedCompanies,
        setSelectedCompanies,
        searchTerm,
        setSearchTerm,
        filteredIndividuals,
        activeFilters,
    };
};
